
export default {
  routeDetails: {
    'routeDetails': 'Útvonal részletei',
    'warnings': 'Figyelmeztetések',
    'routes': 'Útvonalak',
    'route': 'Útvonal',
    'segments': 'Szakaszok',
    'segment': 'Szakasz',
    'instructions': 'Utasítások',
    'instruction': 'Utasítás',
    'name': 'Név',
    'selectRoute': 'Útvonal kiválasztása',
    'selectedRoute': 'Kiválasztott útvonal',
    'gotoSegment': 'Ugrás erre a szakaszra:',
    'warningCodes': {
      '1': 'Egyes utakon korlátozások lehetnek',
      '2': 'Az útvonalon fizetős szakasz is van',
      '3': 'Az útvonalon kihagyott szakaszok is vannak. Előfordulhat, hogy az időtartamok és a behajtási korlátozások pontatlanok',
      '4': 'Legalább egy kiegészítő adat le lett kérve, de nem áll rendelkezésre'
    },
    'routeOpacity': 'Útvonal átlátszatlansága'
  }
}